export const VITE_OTP_GATEWAY_URL = import.meta.env.VITE_OTP_GATEWAY_URL;
export const VITE_ZEM_GATEWAY_URL = import.meta.env.VITE_ZEM_GATEWAY_URL;
export const SITE_TITLE_MAIN = "Car Consultants";

// Initialised enquiry Form Types
export const VEHICLE_ENQUIRY = "Vehicle Enquiry Form";

// App theme settings
export const appSettingsConfig: Record<string, Record<string, string>> = {
	"Car Consultants": {
		themeColor: "#009DEA",
		hoverColor: "#009DEA",
		themeHeaderTxt: "#009DEA",
		bulletBG: "#D6EEF8",
	},
};

// Email typos
export const emailTypos: Record<string, string> = {
	// GMAIL
	"gamil.com": "gmail.com",
	"gmal.com": "gmail.com",
	"gmaill.com": "gmail.com",
	"gmial.com": "gmail.com",
	"gmaii.com": "gmail.com",
	"gamil.com.au": "gmail.com.au",
	"gmail.con": "gmail.com",
	"gmail.con.au": "gmail.com.au",
	"gamail.com": "gmail.com",

	// OUTLOOK
	"outlook.con": "outlook.com",
	"outlok.com": "outlook.com",
	"outllok.com": "outlook.com",
	"outlook.con.au": "outlook.com.au",

	// YAHOO
	"yaho.com": "yahoo.com",
	"yaboo.com.au": "yahoo.com.au",
	"yahoo.con.au": "yahoo.com.au",
	"yaho.com.au": "yahoo.com.au",
	"yahoo.con": "yahoo.com",
	"yhoo.com": "yahoo.com",

	// HOTMAIL
	"htmail.com": "hotmail.com",
	"hotmail.con": "hotmail.com",
	"hotmial.com": "hotmail.com",
	"hotmail.con.au": "hotmail.com.au",

	// ICLOUD / BIGPOND
	"icloud.con": "icloud.com",
	"iclou.com": "icloud.com",
	"bigpond.con": "bigpond.com",
	"bigpond.com.au": "bigpond.com",
	"bigpond.con.au": "bigpond.com",
};

export const australian_states: Record<string, string> = {
	NSW: "New South Wales",
	VIC: "Victoria",
	QLD: "Queensland",
	SA: "South Australia",
	WA: "Western Australia",
	TAS: "Tasmania",
	ACT: "Australian Capital Territory",
	NT: "Northern Territory",
};
